import { all, call, put, takeEvery } from "redux-saga/effects";
import { fetchMailsSuccess, showMailMessage } from "actions/Mail";
import { FETCH_ALL_MAIL } from "constants/ActionTypes";

const getMails = async () => {
    try {
        // Example: Fetching mails from a REST API instead of Firebase
        const response = await fetch('/api/mails');  // Replace with your API endpoint
        const data = await response.json();

        const mails = [];

        data.forEach((rawData) => {
            const mail = rawData;

            // Convert object to array if mail.labels exist
            const labels = [];
            if (mail.labels) {
                mail.labels.forEach((label) => labels.push(label));
            }

            // Convert object to array if mail.to exist
            const tos = [];
            mail.to.forEach((to) => tos.push(to));

            mail.to = tos;
            mail.labels = labels;
            mails.push(mail);
        });

        return mails;
    } catch (error) {
        console.error('Error fetching mails:', error);
        return error;
    }
};

function* fetchMailRequest() {
  try {
    const fetchedMail = yield call(getMails);
    yield put(fetchMailsSuccess(fetchedMail));
  } catch (error) {
    yield put(showMailMessage(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(FETCH_ALL_MAIL, fetchMailRequest)]);
}
